{
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "type": "each",
      "field": "#/properties/terminationRules",
      "presentation": "table",
      "rowId": "termination_rules_table",
      "removeStyle": "hidden",
      "addVisibleWhen": { "field": "__never__", "equals": true },
      "itemFields": [
        {
          "name": "terminationTypeName",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 180
        },
        {
          "name": "expirationInMonths",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 80,
          "maxWidthPx": 120
        },
        {
          "name": "expirationInDays",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 80,
          "maxWidthPx": 120
        },
        {
          "name": "cancelShareTypeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 220
        },
        {
          "name": "awardAdjustmentMethodId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 220
        }
      ]
    }
  ]
}
